<div class="edit-page-root-container reasons-edit-root-container">
  <div class="page-content">
    <div class="page-header">
      <button mat-button class="nav-button" (click)="navBack()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div class="title">
        {{getTitle()}}
      </div>
      <div class="action-btn-container">
              @if(permission.can_edit){
        <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
        <button mat-flat-button class="action-btn btn-save" (click)="save()">SAVE</button>
              }
      </div>
    </div>
    <div class="page-details">
      <form class="edit-form" *ngIf="editForm" [formGroup]="editForm" (keydown.enter)="onEnter($event)">
        <div class="detail-section">
          <div class="content-container">
            <div class="input-group">
              <div class="color-container">
                <mat-form-field class="color-container-div">
                  <mat-label>Code</mat-label>
                  <input matInput formControlName="code" [readonly]="comboInfo.id!==undefined && comboInfo.id!==0">
                  <mat-error *ngIf="editForm.controls['code'].hasError('required')">Combo code
                    should be
                    entered</mat-error>
                  <mat-error *ngIf="editForm.controls['code'].hasError('maxlength')">Maximum length is
                    10.</mat-error>
                </mat-form-field>

                <mat-form-field class="color-container-div">
                  <mat-label>Name</mat-label>
                  <input matInput formControlName="name">
                  <mat-error *ngIf="editForm.controls['name'].hasError('required')">Combo name
                    should be
                    entered</mat-error>
                  <mat-error *ngIf="editForm.controls['name'].hasError('maxlength')">Maximum length is
                    50.</mat-error>
                </mat-form-field>

                <mat-form-field class="color-container-div">
                  <mat-label>Display Name</mat-label>
                  <input matInput formControlName="display_name">
                  <mat-error *ngIf="editForm.controls['display_name'].hasError('required')">Display name
                                        should be
                                        entered</mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="input-group">
              <mat-form-field class="description" style="width: 100%;">
                <mat-label>Description</mat-label>
                <textarea matInput formControlName="description"></textarea>
                <!-- <mat-error *ngIf="editForm.controls['description'].hasError('maxlength')">Maximum length
                                is
                                200.</mat-error> -->
              </mat-form-field>
              <!-- <mat-form-field class="name">
                                    <mat-label>Display Order</mat-label>
                                    <input matInput formControlName="display_order" type="number">
                                   
                                </mat-form-field> -->
            </div>



            <!-- <div class="input-group">
              <div class="color-container">
                <mat-form-field class="color-container-div">
                  <mat-label>Option For</mat-label>
                  <mat-select formControlName="option_for">
                    <mat-option *ngFor="let opfr of optionForList" [value]="opfr.name">
                      {{ opfr.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field class="color-container-div">
                  <mat-label>Background Color</mat-label>
                  <input matInput formControlName="bg_color" type="color">
                </mat-form-field>
                <mat-form-field class="color-container-div">
                  <mat-label>Foreground color</mat-label>
                  <input matInput type="color" formControlName="fg_color">
                </mat-form-field>
              </div>
            </div> -->
            <div>
              <div class="table-responsive-wrapper">
                <table id="attributes" style="margin-top: 5px;">
                  <thead>
                    <tr>
                      <th class="table-column-medium">SALE ITEM</th>
                      <th class="table-column-medium">NAME</th>
                      <th class="table-column-small">
                        QTY</th>
                      <th class="table-column-small">
                        PRICE</th>
                      <th class="table-column-small">IS PERC.</th>
                      <th class="table-column-medium">VAR</th>
                      <th class="table-column-medium">DISC.PRICE</th>
                      <th class="table-column-small">DEFAULT</th>
                      <th class="table-column-small">DISP.ORD</th>
                      <th><button mat-raised-button color="primary" (click)="addOption()">
                          Add</button></th>
                    </tr>
                  </thead>
                  <tbody formArrayName="comboOptionValues">
                    <tr *ngFor="let group of options.controls; let i = index" [formGroupName]="i">
                      <td>
                        <mat-form-field>
                          <input matInput type="text" [formControlName]="'sale_item'" placeholder="Select Sale Item"
                            [matAutocomplete]="saleItemAutoComplete" (input)="filterSaleItems(i)"
                            (focus)="filterSaleItems(i)">
                          <button *ngIf="group.get('sale_item')?.value" (click)="clearSaleItem(i)" matSuffix
                            mat-icon-button aria-label="Clear">
                            <mat-icon
                              style="color: rgb(29 28 28 / 38%); font-weight: 500; font-size: 22px;">close</mat-icon>
                          </button>
                          <mat-autocomplete [displayWith]="displaySaleItemName.bind(this)"
                            #saleItemAutoComplete="matAutocomplete" (optionSelected)="onSaleItemSelected($event, i)">
                            <mat-option *ngFor="let item of filteredSaleItemsArray[i]" [value]="item">
                              <span>{{item.name}}</span>
                            </mat-option>
                          </mat-autocomplete>
                          <mat-error *ngIf="group.get('sale_item')?.hasError('invalidSaleItem')">
                            Invalid sale item selected.
                          </mat-error>
                          <mat-error *ngIf="group.get('sale_item')?.hasError('required')">
                            Enter sale item.
                          </mat-error>
                        </mat-form-field>
                      </td>
                      <td>
                        <mat-form-field>
                          <input matInput placeholder="Name" formControlName="name">
                          <mat-error *ngIf="group.get('name')?.hasError('required')">
                          Enter name.
                          </mat-error>
                        </mat-form-field>
                      </td>
                      <td>
                        <mat-form-field style="width: 80px;">
                          <input class="right-align" matInput type="number" formControlName="def_qty">
                        </mat-form-field>
                      </td>
                      <td>
                        <mat-form-field style="width: 100px;">
                          <input class="right-align" matInput formControlName="price" aria-disabled="true">
                        </mat-form-field>
                      </td>
                      <td>
                        <mat-checkbox formControlName="is_percentage" style="margin-left: 11px;"></mat-checkbox>
                      </td>
                      <td>
                        <mat-form-field style="width: 100px;">
                          <input class="right-align" matInput formControlName="price_variance">$
                        </mat-form-field>
                      </td>
                      <td>
                        <mat-form-field style="width: 100px;">
                          <input class="right-align" matInput formControlName="disc_price" readonly>
                        </mat-form-field>
                      </td>


                      <td class="center-cell" style="height: 57px;
    padding-bottom: 21px;">
                        <mat-radio-group [value]="getDefaultIndex()" (change)="setDefault($event.value)">
                          <mat-radio-button [value]="i"></mat-radio-button>
                        </mat-radio-group>
                      </td>
                      <td>
                        <mat-form-field style="width: 100px;">
                          <input class="right-align" matInput type="number" formControlName="display_order">
                          <mat-error *ngIf="group.get('display_order')?.hasError('required')">
                            Enter disp.ord.
                          </mat-error>
                        </mat-form-field>
                      </td>
                      <td style="text-align: center;">
                        <button mat-icon-button aria-label="Delete" (click)="removeOption(i)">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>